
import AuthService from '@/services/AuthService';

const state = {
  accessToken: null,
  error: null,
  isLoading: false
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  }
};

const actions = {
  async loginWithGoogle({ commit }, googleTokenId) {
    commit('setLoading', true);
    try {
      const response = await AuthService.loginWithGoogle(googleTokenId);
      if (response.data.error) {
        commit('setError', 'Error al iniciar sesión');
      } else {
        console.log(response.data.Token);
        commit('setAccessToken', response.data.Token);
        this.$router.replace({ name: 'home' });
      }
    } catch (error) {
      commit('setError', 'Error inesperado');
    } finally {
      commit('setLoading', false);
    }
  }
};

const getters = {
  accessToken: state => state.accessToken,
  isLoading: state => state.isLoading,
  error: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
